// extracted by mini-css-extract-plugin
export default {"initialPageL1":"InitialPageL1_initialPageL1__yFRZj","barGraph":"InitialPageL1_barGraph__aOyXF","graph":"InitialPageL1_graph__zYp9V"};